import * as Yup from 'yup';
import { hasCitiesAvailable } from 'src/utils/address';

export default (addressData = { cities: [] }, isLoadingAddress = false) => {
  const hasCities = hasCitiesAvailable(addressData, isLoadingAddress);
  
  return Yup.object().shape({
    equipmentLocation: Yup.object().shape({
      zipCode: Yup.string()
        .matches(/^[0-9]{5}$/, 'SCHEMA_ERRORS.ZIP_CODE_INVALID')
        .required('SCHEMA_ERRORS.ZIP_CODE_REQUIRED'),
      street: Yup.string().required('SCHEMA_ERRORS.STREET_REQUIRED'),
      insideHomeNumber: Yup.string().nullable(),
      externalHomeNumber: Yup.string().required(
        'SCHEMA_ERRORS.EXTERNAL_HOME_NUMBER_REQUIRED'
      ),
      colonia: Yup.string(),
      municipality: Yup.string(),
      city: hasCities
        ? Yup.string().required('SCHEMA_ERRORS.CITY_REQUIRED')
        : Yup.string().nullable(),
      state: Yup.string().required('SCHEMA_ERRORS.STATE_REQUIRED'),
      includeClientAddress: Yup.boolean()
    })
  });
};
